<script setup lang="ts">
import {
  CLEANING_PRICES,
  BCC_CLEANING_PRICES_APARTMENT,
  BCC_CLEANING_PRICES_HOUSE,
} from "~/constants/values/services/mainCleaningData";
import {useIsHouseHomeType} from "~/composables/store/services/service_inputs";
import formatPrice from "~/utils/formatPrice";

const emit = defineEmits(['changeService'])
const props = defineProps({
  servicesWithInputs: Array
})
const standardB2CServices = {
  'standartnaya-uborka': true,
  'generalnaya-uborka': true,
  'uborka-doma-posle-remonta': true,
}

const route = useRoute()
const isHouse = useIsHouseHomeType()
const cleaningPrices = computed(() => {
  if (!route.path.startsWith('/bcc')) return CLEANING_PRICES
  return isHouse.value ? BCC_CLEANING_PRICES_HOUSE : BCC_CLEANING_PRICES_APARTMENT
})

const selectedServiceId = defineModel()
function changeService(service) {
  emit('changeService', service)
}
</script>

<template>
  <div class="form_block px-0 md:py-5 py-3">
    <div class="flex items-center justify-between gap-3 md:px-5 px-3">
      <p class="md:text-lg text-sm font-bold">{{ $t('order_page.titles.cleaning_type') }}</p>
      <slot name="header-action"></slot>
    </div>

    <div class="flex flex-col gap-[9px] md:px-5 px-3">
      <button
          @click="changeService(serv)"
          v-for="serv in servicesWithInputs"
          :key="serv.service_id"
          type="button"
          class="flex items-center justify-between w-full text-left py-[13px] px-[15px] rounded-[14px] border-[1.5px]"
          :class="selectedServiceId === serv.service_id
            ? 'border-primary-green bg-primary-green bg-opacity-[0.08]'
            : 'border-[#E8EAE8] bg-white'"
      >
        <div class="flex-1 min-w-0 pr-3">
          <div class="text-sm font-semibold text-[#16211C]">
            {{ standardB2CServices[serv?.keyword] ? $t(`order.home_calculator.cleaning_types.${serv.keyword}`) : serv.title }}
          </div>
          <div v-if="standardB2CServices[serv?.keyword]" class="text-xs text-[#8A938E] leading-[1.4] mt-0.5">
            {{ $t(`order.home_calculator.cleaning_types_description.${serv.keyword}`) }}
          </div>
        </div>
        <span
            v-if="cleaningPrices[serv?.keyword]"
            class="text-[13px] font-bold flex-none"
            :class="selectedServiceId === serv.service_id ? 'text-primary-green' : 'text-[#5B6660]'"
        >{{ $t('order_page.from_price', {price: formatPrice(cleaningPrices[serv.keyword])}) }}</span>
      </button>
    </div>
  </div>
</template>

<style scoped>

</style>